import React, { useMemo, useRef, useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../assets/apiRoutes.json";
import { LaborTrackingRoutes, LaborTrackingEntryModes } from "../../../const/constants";
import { GridLayout } from "../../../common/GridLayout";
import AccordionReact from 'devextreme-react/accordion';
import { Button } from 'devextreme-react/button';
import Toolbar, { Item as ToolbarItem } from "devextreme-react/toolbar";
import FormField from '../../../dynamicFormBuilder/FormField';
import {
    Column,
    DataGrid,
    Lookup,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    HeaderFilter,
    SearchPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import '../../../common/css/searchPage.css';

const numberFormat = { type: "fixedPoint", precision: 2 };

const searchpanel = [{ ID: 1, Title: 'Search Filters' }];

// Search fields for the Enter Labor Tracking screen (Customer Name / Worker Name / Department).
const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            { "name": "customerName", "tableName": "", "label": "Customer Name", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "workerName", "tableName": "", "label": "Worker Name", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
        ]
    },     {
        "groupId": 2,
        "fields": [
            { "name": "department", "tableName": "", "label": "Department", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
        ]
    }
];

// Build a server-side DevExtreme filter from the search fields (contains match).
const buildFilters = (fields) => {
    const map = [
        ["customerName", fields.customerName],
        ["workerName", fields.workerName],
        ["department", fields.department],
    ];
    const parts = map
        .filter(([, value]) => value)
        .map(([column, value]) => [column, "contains", value]);
    if (parts.length === 0) {
        return null;
    }
    return parts.reduce((acc, part, index) => (index === 0 ? [part] : [...acc, "and", part]), []);
};

// Enter Labor Tracking — lists all WM labor-tracking records for the company
// (wm/TransactionLaborTracking/GetAllLaborTrackings, server-side DataSourceLoader).
const LaborTrackingList = (props) => {
    const accessToken = props.oidc.user.access_token;
    const currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const history = useHistory();
    const dataGrid = useRef(null);
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const [resultData, setResultData] = useState(null);

    const initialFormFields = { customerName: '', workerName: '', department: '' };
    const [formFields, setformFields] = useState(initialFormFields);

    const allowedPageSizes = [10, 20, 100, 500, "all"];
    const gridKey = "5C9A2E14-7B63-4D80-9F51-3A8D6C0E4B29";
    const loadState = useCallback(() => GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout), [currentLayout]);
    const saveState = useCallback((state) => GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout), [currentLayout]);

    const selectedRowId = useRef(null);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);

    // Enable Edit only when exactly one row is selected; remember its key for the edit page.
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length === 1) {
            selectedRowId.current = selectedRowsData[0].rowid;
            setIsEditButtonDisabled(false);
        } else {
            selectedRowId.current = null;
            setIsEditButtonDisabled(true);
        }
    };

    const handleEditClick = () => history.push(`${LaborTrackingRoutes.Edit}?id=${selectedRowId.current}`);
    const handleCreateClick = () => history.push(LaborTrackingRoutes.Create);

    const loadDatasource = useCallback(() => {
        const store = createStore({
            key: 'rowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionLaborTracking.GetAllLaborTrackings}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return new DataSource({ store });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setResultData(loadDatasource());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSearch = (e) => {
        e.event.stopPropagation();
        const dataSource = loadDatasource();
        const filters = buildFilters(formFields);
        if (filters) {
            dataSource.filter(filters);
        }
        setResultData(dataSource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setResultData(loadDatasource());
    };

    const handleFieldChange = useCallback((name, value) => { }, []);
    const handleFormLoad = useCallback(() => { }, []);

    return (
        <div className="row">
            <div className="col-md-12 main-page">
                <div id="accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={(e) => setSelectedItems(e.component.option('selectedItems'))}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <ToolbarItem location="before">
                                    <div className="title">
                                        <h6 style={{ color: window._env_.Color2 }}>Enter Your Query For Labor Tracking</h6>
                                    </div>
                                </ToolbarItem>
                                <ToolbarItem location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </ToolbarItem>
                                <ToolbarItem location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </ToolbarItem>
                            </Toolbar>
                        )}
                        itemRender={() => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='B7E4C2A9-6D31-4F08-9A25-3C8E1D5B70F6'
                                layoutName='LaborTrackingSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        dataSource={resultData}
                        keyExpr="rowid"
                        onSelectionChanged={onSelectionChanged}
                        className={selectedItems.length ? "GridHeightAccordianOpen" : "GridHeightAccordianClose"}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        showBorders={true}
                        hoverStateEnabled={true}
                        columnAutoWidth={true}
                        remoteOperations={true}
                    >
                        <ColumnChooser enabled={true} title="Choose Column" width={290} height={290} sortOrder="asc">
                            <ColumnChooserSearch enabled={true} editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="single" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager visible={true} showPageSizeSelector={true} allowedPageSizes={allowedPageSizes} showNavigationButtons={true} />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <HeaderFilter visible={true} />
                        <SearchPanel visible={true} width={240} placeholder="Search..." />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring enabled={true} type="custom" customLoad={loadState} storageKey={gridKey} customSave={saveState} />

                        {/* Default-visible columns */}
                        <Column dataField="transactionNumber" caption="Transaction #" />
                        <Column dataField="workerId" caption="Worker ID" />
                        <Column dataField="workerName" caption="Worker Name" />
                        <Column dataField="customerId" caption="Customer ID" />
                        <Column dataField="customerName" caption="Customer Name" />
                        <Column dataField="activity" caption="Activity" />
                        <Column dataField="department" caption="Department" />
                        <Column dataField="startDate" caption="Start Date" dataType="datetime" format="MM/dd/yyyy hh:mm a" defaultSortIndex={0} defaultSortOrder="desc" />
                        <Column dataField="endDate" caption="End Date" dataType="datetime" format="MM/dd/yyyy hh:mm a" />
                        <Column dataField="elapsedHours" caption="Elapsed Hours" dataType="number" />
                        <Column dataField="elapsedMinutes" caption="Elapsed Minutes" dataType="number" />
                        <Column dataField="workUnitQuantity" caption="Work Unit Qty" dataType="number" format={numberFormat} />
                        <Column dataField="workUnitUOM" caption="Work Unit UOM" />

                        {/* Column-chooser (hidden by default) */}
                        <Column dataField="departmentDescription" caption="Department Description" visible={false} />
                        <Column dataField="recordNumber" caption="Record #" visible={false} />
                        <Column dataField="entryMode" caption="Entry Mode" visible={false}>
                            <Lookup dataSource={LaborTrackingEntryModes} valueExpr="code" displayExpr="name" />
                        </Column>
                        <Column dataField="taskCount" caption="Task Count" dataType="number" visible={false} />
                        <Column dataField="taskTotalMinutes" caption="Task Total Minutes" dataType="number" visible={false} />
                        <Column dataField="userDefinedCode1" caption="Code 1" visible={false} />
                        <Column dataField="userDefinedCode2" caption="Code 2" visible={false} />
                        <Column dataField="userDefinedCode3" caption="Code 3" visible={false} />
                        <Column dataField="userDefinedReference1" caption="Reference 1" visible={false} />
                        <Column dataField="userDefinedReference2" caption="Reference 2" visible={false} />
                        <Column dataField="userDefinedReference3" caption="Reference 3" visible={false} />
                        <Column dataField="userDefinedQuantity1" caption="Quantity 1" dataType="number" visible={false} />
                        <Column dataField="userDefinedQuantity2" caption="Quantity 2" dataType="number" visible={false} />
                        <Column dataField="userDefinedQuantity3" caption="Quantity 3" dataType="number" visible={false} />
                        <Column dataField="comment" caption="Comment" visible={false} />
                        <Column dataField="createdBy" caption="Created By" visible={false} />
                        <Column dataField="creationDate" caption="Creation Date" dataType="date" visible={false} />
                        <Column dataField="lastUpdatedBy" caption="Last Updated By" visible={false} />
                        <Column dataField="lastUpdated" caption="Last Updated" dataType="date" visible={false} />
                        <Column dataField="module" caption="Module" visible={false} />
                        <Column dataField="recordType" caption="Record Type" visible={false} />
                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button disabled={isEditButtonDisabled} onClick={handleEditClick} type="default" text="Edit" />
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <Button onClick={handleCreateClick} type="default" text="Create" />
                            </GridToolbarItem>
                            <GridToolbarItem name="exportButton" />
                            <GridToolbarItem name="columnChooserButton" />
                        </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(LaborTrackingList);
